/**
 * OneNextActionCard — Dashboard State Architecture, Step 3.
 *
 * Renders only in State 1 ("Just Arrived"). A calm, single-action anchor
 * that gives a brand-new candidate exactly one meaningful next step.
 *
 * Per `/app/memory/UX_DASHBOARD_STATE_ARCHITECTURE.md` §6:
 *   - one affordance only
 *   - no secondary actions
 *   - no progress, no checklist, no skip, no learn-more
 *   - no illustrations, no gradients, no animations
 *   - the muted footer is the only acknowledgement that the dashboard
 *     will grow as the user builds.
 */

import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileText } from 'lucide-react';

export function OneNextActionCard({ onPrimaryAction }) {
  return (
    <Card
      data-testid="one-next-action-card"
      className="border border-slate-200 shadow-none mb-6"
    >
      <div className="px-6 py-7 sm:px-8 sm:py-8">
        <div className="flex items-start gap-4 max-w-xl">
          <div className="hidden sm:flex flex-shrink-0 mt-1">
            <FileText className="w-6 h-6 text-slate-400" strokeWidth={1.5} aria-hidden="true" />
          </div>
          <div>
            <h2
              className="text-lg font-semibold text-slate-900 mb-1"
              data-testid="one-next-action-title"
            >
              Begin your transition documents
            </h2>
            <p className="text-sm text-slate-600 mb-5">
              Start with a few basic details and your military experience. Sergeant TAP will help translate your service into civilian opportunities.
            </p>
            <Button
              data-testid="one-next-action-primary-btn"
              onClick={onPrimaryAction}
              className="bg-brand hover:bg-brand-hover text-white"
              size="sm"
            >
              Open my resume
            </Button>
          </div>
        </div>
      </div>
      <div className="px-6 pb-5 sm:px-8 sm:pb-6">
        <p
          className="text-[11px] text-slate-400"
          data-testid="one-next-action-footer"
        >
          More appears here as you build.
        </p>
      </div>
    </Card>
  );
}

export default OneNextActionCard;
